import React from 'react'
import { useTranslation } from '../hooks/use-i18n'

export const APP_STORE_URL = 'https://apps.apple.com/us/app/restoside/id6783776598'

interface Props {
  className?: string
  onClick?: () => void
  /** Pill CTA matching “Start for Free” size */
  variant?: 'default' | 'cta'
}

const AppStoreButton: React.FC<Props> = ({ className = '', onClick, variant = 'default' }) => {
  const { t } = useTranslation()

  const isCta = variant === 'cta'

  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={
        isCta
          ? `inline-flex justify-center items-center gap-2 px-6 sm:px-8 py-3.5 sm:py-4 rounded-full text-sm sm:text-base font-semibold text-[#0f1623] transition-transform hover:scale-[1.02] whitespace-nowrap ${className}`
          : `inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-white/10 text-white font-semibold hover:bg-white/15 transition-colors whitespace-nowrap px-3 py-2 text-sm ${className}`
      }
      style={isCta ? { backgroundColor: '#38bdf8' } : undefined}
    >
      <svg className={isCta ? 'w-5 h-5' : 'w-4 h-4'} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
      </svg>
      {t('nav.appStore')}
    </a>
  )
}

export default AppStoreButton
